import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
	title: 'FoodcourtFinance',
	description:
		'The most popular AMM on BSC by user count! Earn COUPON through yield farming or win it in the Lottery, then stake it in Syrup Pools to earn more tokens! Initial Farm Offerings (new token launch model pioneered by FoodcourtFinance), NFTs, and more, on a platform you can trust.',
	image: 'https://www.foodcourt.finance/images/hero.png',
}

export const customMeta: { [key: string]: PageMeta } = {
	'/': {
		title: 'Home | FoodcourtFinance',
	},
	'/competition': {
		title: 'Trading Battle | FoodcourtFinance',
	},
	'/prediction': {
		title: 'Prediction | FoodcourtFinance',
	},
	'/farms': {
		title: 'Farms | FoodcourtFinance',
	},
	'/pools': {
		title: 'Pools | FoodcourtFinance',
	},
	'/lottery': {
		title: 'Lottery | FoodcourtFinance',
	},
	'/collectibles': {
		title: 'Collectibles | FoodcourtFinance',
	},
	'/ifo': {
		title: 'Initial Farm Offering | FoodcourtFinance',
	},
	'/teams': {
		title: 'Leaderboard | FoodcourtFinance',
	},
	'/profile/tasks': {
		title: 'Task Center | FoodcourtFinance',
	},
	'/profile': {
		title: 'Your Profile | FoodcourtFinance',
	},
}
